import { render } from "./SenderTemplate.vue?vue&type=template&id=22a1d1ee&scoped=true"
import script from "./SenderTemplate.vue?vue&type=script&lang=ts"
export * from "./SenderTemplate.vue?vue&type=script&lang=ts"

import "./SenderTemplate.vue?vue&type=style&index=0&id=22a1d1ee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22a1d1ee"

export default script